<template>
  <div class="col-12">
    <chart-card title="Call Overview Line Chart"
                sub-title="Group Call by different categories"
                v-if="!isFetchingCalls"
                :chart-data="data"
                :chart-options="options"
                footer-text='Last Two weeks (Default)'
    >
      <div class="row" slot="filter">
        <div class="col-12">
          <div class="dropdown menu">
            <button class="btn btn-round btn-info dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              Filter
              <!-- by {{tagOptions.find(t => t.value === tag).text}} -->
            </button>
            <div class="dropdown-menu dropdown-menu-left p4">
              <form class="col-12" @submit.prevent>
                <fg-input-dropdown type="text"
                                   label="Group By"
                                   placeholder="e.g Nature"
                                   required
                                   :options="tagOptions"
                                   v-model="tag">
                </fg-input-dropdown>
                <date-range-picker
                  v-model="dateRange"
                  ref="picker"
                  :minDate="minDate"
                  :maxDate="maxDate"
                  opens="right"
                  :locale-data="locale"
                  @update="updateValues"
                >
                  <template v-slot:input="picker" style="min-width: 50px;">
                    {{ picker.startDate | date }} - {{ picker.endDate | date }}
                  </template>
                </date-range-picker>
                <p-button type="success"
                          style="margin-left: auto; display: block;"
                          round
                          @click.native.prevent="fetchWithFilter">
                  Submit
                </p-button>
                <br />
              </form>
            </div>
          </div>
        </div>
      </div>
      <div v-if="!data || data.series.length === 0" slot="empty">No Data Available</div>
    </chart-card>
  </div>
</template>
<script>
import {
  mapState,
  mapActions,
} from 'vuex';
import moment from 'moment';
import Chartist from 'chartist';
import ChartistTooltip from 'chartist-plugin-tooltips-updated';
require('chartist-plugin-legend');
import { ChartCard } from "@/components/index";
import { getCounsellor } from '@/utils/auth'
import {
  isMoreThanAMonth,
  isOneDay,
  minDate,
  nowDate,
  twoWeekEndDate,
  twoWeekStartDate
} from "@/utils/utils";
import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
export default {
  components: {
    ChartCard,
    DateRangePicker
  },
  /**
   * Chart data used to render stats, charts. Should be replaced with server data
   */
  data() {
    return {
      counsellor: null,
      minDate: minDate(),
      maxDate: nowDate(),
      dateRange: {
        startDate: twoWeekStartDate(),
        endDate: twoWeekEndDate()
      },
      locale: {
        direction: 'ltr',
        format: 'mm-dd-yyyy',
        separator: ' to ',
        applyLabel: 'Apply',
        cancelLabel: 'Cancel',
        weekLabel: 'W',
        customRangeLabel: 'Custom Range',
        daysOfWeek: moment.weekdaysMin(),
        monthNames: moment.monthsShort(),
        firstDay: 1
      },
      tag: 'agentId',
      tagOptions: [
        {key: 1, value: "hangupCause", text: "Hangup Cause"},
        {key: 0, value: "callDirection", text: "Call Direction"},
        {key: 1, value: "agentId", text: "Call Handler"},
        {key: 1, value: "callSessionStatus", text: "Status"},
      ],
      config: {
        format: '',
        useCurrent: false,
        showClear: true,
        showClose: true,
      },
      legendNames: [],
      filter: {
        metrics: [
          {
            name: "TotalCalls",
            tags: {
              workspaceId: []
            },
            group_by: [
              {
                name: "tag",
                tags: [
                  "agentId"
                ]
              }
            ],
            aggregators: [
              {
                name: "sum",
                sampling: {
                  value: "1",
                  unit: "hours"
                },
                align_end_time: true
              }
            ]
          }
        ],
        plugins: [],
        cache_time: 0,
        start_absolute: twoWeekStartDate(),
        end_absolute: twoWeekEndDate()
      },
      data: null,
      options: null,
    };
  },
  filters: {
    date(val) {
      return val ? moment(val).format('LL') : "";
    }
  },
  computed: {
    ...mapState('analytics', ['calls', 'isFetchingCalls']),
    ...mapState("auth", ["counsellorList", "isFetchingCounsellorList"]),
  },
  watch: {
    async calls(newValue) {
      await this.formatGraphData(newValue);
    },
    tag(newValue) {
      this.filter.metrics.map(metric => {
        metric.group_by[0].tags = [newValue]
        return metric
      })
    }
  },
  async mounted() {

  },
  async created() {
    this.counsellor = getCounsellor();
    await this.fetchWithFilter()
  },
  methods: {
    ...mapActions('analytics', [
      'fetchCalls',
    ]),
    updateValues({ startDate, endDate }) {
      this.filter.start_absolute = startDate;
      this.filter.end_absolute = endDate;
      this.fetchWithFilter();
    },
    async fetchWithFilter() {
      if (isOneDay(this.filter.start_absolute, this.filter.end_absolute)) {
        const stateDate = moment(this.filter.start_absolute);
        const endDate = moment(this.filter.end_absolute);
        this.filter.start_absolute = stateDate.startOf('day').valueOf()
        this.filter.end_absolute = endDate.endOf('day').valueOf()
        this.filter.metrics.map(metric => {
          metric.aggregators[0].sampling = {
            value: '1',
            unit: 'hours',
          };
          metric.tags.workspaceId = [this.counsellor.workspaceId]
          return metric
        })
      }
      else if (isMoreThanAMonth(this.filter.start_absolute, this.filter.end_absolute)) {
        const stateDate = moment(this.filter.start_absolute);
        const endDate = moment(this.filter.end_absolute);
        this.filter.start_absolute = stateDate.startOf('month').valueOf()
        this.filter.end_absolute = endDate.endOf('month').valueOf()
        this.filter.metrics.map(metric => {
          metric.aggregators[0].sampling = {
            value: '1',
            unit: 'months',
          };
          metric.tags.workspaceId = [this.counsellor.workspaceId]
          return metric
        })
      }
      else {
        const stateDate = moment(this.filter.start_absolute);
        const endDate = moment(this.filter.end_absolute);
        this.filter.start_absolute = stateDate.startOf('day').valueOf()
        this.filter.end_absolute = endDate.endOf('day').valueOf()
        this.filter.metrics.map(metric => {
          metric.aggregators[0].sampling = {
            value: '1',
            unit: 'days',
          };
          metric.tags.workspaceId = [this.counsellor.workspaceId]
          return metric
        })
      }
      const params = this.filter;
      Object.keys(params).forEach((key) => (params[key] === null || params[key] === '') && delete params[key]);

      //console.log("PARAM " + JSON.stringify(params))
      await this.fetchCalls(params);
    },
    getExpectedTimeStamps (start, end) {
      const expectedTimeStamps = [];
      const startDate          = moment(start);
      const endDate            = moment(end);
      if (isOneDay(this.filter.start_absolute, this.filter.end_absolute)) {
        while (startDate.isBefore(endDate)) {
          expectedTimeStamps.push(startDate.format('h:mm a'));
          startDate.add(1, 'hours');
        }
      }
      else if (isMoreThanAMonth(this.filter.start_absolute, this.filter.end_absolute)) {
        while (startDate.isBefore(endDate)) {
          expectedTimeStamps.push(startDate.format('MMMM YYYY'));
          startDate.add(1, 'months');
        }
      }
      else {
        while (startDate.isBefore(endDate)) {
          expectedTimeStamps.push(startDate.format('YYYY-MM-DD'));
          startDate.add(1, 'days');
        }
      }
      return expectedTimeStamps;
    },
    async formatGraphData() {
      this.data = {
        labels: [],
        series: []
      }
      this.legendNames = []
      this.options = {
        low: 0,
        showArea: false,
        height: "350px",
        axisX: {
          showGrid: true
        },
        axisY: {
          onlyInteger: true
        },
        lineSmooth: Chartist.Interpolation.simple({
          divisor: 3
        }),
        labelOffset: 70,
        labelDirection: 'explode',
        showLine: true,
        pointRadius: 0.3,
        pointHoverRadius: 0.3,
        plugins: [
          Chartist.plugins.tooltip(),
          ChartistTooltip(),
          Chartist.plugins.legend({
            position: 'bottom',
            legendNames: this.legendNames,
          })
        ]
      }
      const expectedTimeStamps = this.getExpectedTimeStamps(
        this.filter.start_absolute,
        this.filter.end_absolute
      );
      expectedTimeStamps.forEach((timestamp, idx) => {
        if (!this.data.labels.includes(timestamp)) this.data.labels.push(timestamp);
      });
      //console.log("EXPECTED FOR CALLS", expectedTimeStamps)
      this.calls.queries.forEach(query => {
        query.results.forEach((result, idx) => {
          switch (result.name) {
            case 'TotalCalls':
              const resultTimestamps = result.values.map(value => {
                //console.log("VALUE ", value[0], moment(value[0]).format('YYYY-MM-DD'), value[1])
                if (isOneDay(this.filter.start_absolute, this.filter.end_absolute)) {
                  return moment(value[0]).subtract(1, "hours").format('h:mm a')
                }
                else if (isMoreThanAMonth(this.filter.start_absolute, this.filter.end_absolute)) {
                  return moment(value[0]).subtract(1, 'months').format('MMMM YYYY')
                }
                else {
                  return moment(value[0]).subtract(1, 'day').format('YYYY-MM-DD')
                }
              });

              //console.log("RESULT FOR TOTAL CALL COUNTS ", resultTimestamps)

              if (this.tag === 'agentId') {
                if (result.group_by[0].group.agentId === '') {
                  this.legendNames.push('Unassigned*')
                } else {
                  const agent = this.counsellorList.find(c => c.uuid === result.group_by[0].group.agentId)
                  agent ? this.legendNames.push(agent.name) : this.legendNames.push(result.group_by[0].group.agentId)
                }
              } else {
                this.legendNames.push(result.group_by[0].group[this.tag]);
              }

              const resultMap = result.values.reduce((map, value) => {
                if (isOneDay(this.filter.start_absolute, this.filter.end_absolute)) {
                  map[moment(value[0]).subtract(1, "hours").format('h:mm a')] = value[1];
                  return map;
                }
                else if (isMoreThanAMonth(this.filter.start_absolute, this.filter.end_absolute)) {
                  map[moment(value[0]).subtract(1, 'months').format('MMMM YYYY')] = value[1]
                  return map;
                }
                else {
                  map[moment(value[0]).subtract(1, 'days').format('YYYY-MM-DD')] = value[1]
                  return map;
                }
              }, {});

              //console.log("RESULT MAP ", JSON.stringify(resultMap))

              const elements = [];
              expectedTimeStamps.forEach((timestamp, idx) => {
                if (resultTimestamps.includes(timestamp)) {
                  elements.push(resultMap[timestamp]);
                } else {
                  elements.push(0);
                }
              });
              this.data.series.push(elements);

              break;
            default:
              break;
          }
        })
        // console.log({datadatadatadata: this.data })
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.menu.dropdown {
  margin-bottom: 15px
}
</style>
